import React from 'react';
import { Typography } from 'antd';

const { Title } = Typography;

const CountCard = ({ title, count, icon }) => {
  return (
    <div
      className='dashboard-shadow'
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        height: "110px",
        padding: "12px 16px"
      }}
    >
      <div style={{ flex: 1, paddingRight: "10px" }}>
        <p
          style={{
            color: "#8c8c8c",
            fontSize: "14px",
            marginBottom: "4px",
            marginTop: 0
          }}
        >
          {title}
        </p>

        <Title
          level={4}
          style={{
            margin: 0,
            lineHeight: "1.2",
            wordBreak: "break-word"
          }}
        >
          {count}
        </Title>
      </div>

      <div
        style={{
          backgroundColor: "#696cff",
          borderRadius: "10px",
          width: "48px",
          height: "48px",
          color: "#fff",
          fontSize: "28px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0
        }}
      >
        {icon}
      </div>
    </div>
  );
};

export default CountCard;